import React, { Component } from 'react';
import { trackingShowEmptyScreen } from '../NotificationCenter/tracking';

export class NoNotifications extends Component {
  public componentDidMount() {
    trackingShowEmptyScreen();
  }

  public render() {
    return (
      <div className="c-header-modal__empty-wrapper">
        <div className="c-header-modal__empty">
          <div className="c-header-modal__empty-bell" />
          <div className="c-header-modal__empty-content">
            <h4 className="c-header-modal__empty-header">Еще нет уведомлений</h4>
            <p className="c-header-modal__empty-text">
              Здесь будут уведомления об изменении цены, новых объявлениях по вашему поиску
            </p>
          </div>
        </div>
      </div>
    );
  }
}
